import { FC } from 'react'

import { styled } from 'styled-components'

type MaterialIconRoundedProps = {
  name: string
  outlined?: boolean
}

const MaterialIconRounded: FC<MaterialIconRoundedProps> = ({ name, outlined = false }) => (
  <Span $outlined={outlined} className='material-symbols-rounded'>
    {name}
  </Span>
)

export default MaterialIconRounded

const Span = styled.span<{ $outlined: boolean }>`
  font-size: inherit;
  font-variation-settings: 'FILL' ${(p) => (p.$outlined ? '0' : '1')};
  user-select: none;
`
